import {Input} from 'antd';

import {AdditionalInfo} from '../../../../../../../../layout/additional-info/additional-info';
import {Locale} from '../../../../../../../../provider/locale/localization';
import {useFormRules} from '../../../../../../../../service/form/form-rules-hook';
import {Form} from '../../../../../../../../typings/antd';

// Yandex limits, a mirror of the backend: `ShortNameMapper.max_length` and, for a company allowed to keep a
// short name longer than the full one, `ShortNameMapper.max_length_when_longer_than_main_allowed`.
// Change them here as well when the mapper changes.
// The "not longer than the full name" rule itself is validated by the backend only — it needs names the
// form does not always have (other locales, stored values) — and it does not apply to the raised limit
// (`InformationValidator._validate_short_name` leaves before the check).
const shortNameMaxLength = 55;
const shortNameMaxLengthWhenLongerThanNameAllowed = 75;

type PropsType = {
    showLabel: boolean;
    fieldName: number;
    allowLongerThanName: boolean;
};

export function ShortNameInput(props: PropsType): JSX.Element {
    const {showLabel, fieldName, allowLongerThanName} = props;

    const {maxLengthFieldRule, whitespaceFieldRule} = useFormRules();

    const maxLength = allowLongerThanName ? shortNameMaxLengthWhenLongerThanNameAllowed : shortNameMaxLength;

    const label = showLabel ? (
        <AdditionalInfo leftNode={<Locale stringKey="COMPANY_FORM__NAMES__SHORT_NAME__LABEL" />}>
            <Locale
                stringKey={
                    allowLongerThanName
                        ? 'COMPANY_FORM__NAMES__SHORT_NAME__HINT_ANY_LENGTH'
                        : 'COMPANY_FORM__NAMES__SHORT_NAME__HINT'
                }
                valueMap={{length: maxLength}}
            />
        </AdditionalInfo>
    ) : null;

    return (
        <Form.Item
            label={label}
            name={[fieldName, 'shortName']}
            rules={[maxLengthFieldRule(maxLength), whitespaceFieldRule]}
        >
            {/* No placeholder: the column has a label with a hint, and an example of a short name would only
                repeat the full name next to it */}
            <Input size={showLabel ? 'large' : 'middle'} />
        </Form.Item>
    );
}
